import cn from 'bem-cn';

import { Skeleton, Stack } from '../../UI';

import './ChallengeInfoHeader.scss';

const b = cn('challenge-info-header');

export const ChallengeInfoHeaderSkeleton = () => {
    return (
        <Stack className={b()}>
            <Stack className={b('text-container')}>
                <Stack direction="row" className={b('tags')} justifyContent="center">
                    <Skeleton variant="rounded" width={60} height={28} />
                    <Skeleton variant="rounded" width={80} height={28} />
                </Stack>
                <Stack spacing={8}>
                    <h1 className={b('title')}>
                        <Skeleton width="70" />
                    </h1>
                    <Stack spacing={4} className={b('description')} alignItems="center">
                        <Skeleton width="90%" />
                        <Skeleton width="80%" />
                        <Skeleton />
                        <Skeleton width="90%" />
                        <Skeleton width="50%" />
                    </Stack>
                </Stack>
            </Stack>
            <div className={b('video-container')}>
                <Skeleton variant="rounded" className={b('video', { skeleton: true })} />
            </div>
        </Stack>
    );
};
